import React from 'react';
import iconWarning from '@/assets/app/images/icon/icon-warning.png';
import AppButton from '@/shared/components/ui/new/AppButton';
import useAppAuthStore, { getAuthState } from '@/shared/store/UseAppAuthStore';
import { vAppAjax } from '@/shared/utils/CommonUtil';
import logger from '@/shared/utils/Logger';

interface DeleteMemberSheetProps {
  onCancel: () => void;
}

export const DeleteMemberSheet: React.FC<DeleteMemberSheetProps> = ({ onCancel }) => {
  const deleteMember = async () => {
    const logout = getAuthState().logout;
    await vAppAjax(
      'post',
      'members/delete',
      {},
      (response: AxiosResponse<CommonResult>) => {
        if (response.data.code === 200) {
          logout();
        } else {
          logger.error(response.data.message);
        }
      },
      (error: any) => {
        logger.error(error);
      },
    );
  };

  return (
    <div className="p-2 flex flex-col items-center text-center">
      <h3 className="text-[20px] font-bold leading-tight mb-2 text-[#14A1C8]">
        계정이 삭제 된 후에는
        <br />
        복구가 불가능합니다
      </h3>
      <p className="text-[#333333] text-[20px]">
        정말로 계정삭제를
        <br />
        진행하시겠습니까?
      </p>

      {/* 경고 박스 영역 */}
      <div className="w-full rounded-2xl p-4 flex items-start gap-3 mb-2 text-left text-[14px] justify-center">
        <img src={iconWarning} alt="warning" className="w-10 h-10 shrink-0" />
        <div>
          <p className="text-[#FF4D4D] font-bold text-sm">알아두세요!</p>
          <p className="text-[#FF4D4D]" style={{ lineHeight: 1.2 }}>
            계정 삭제 후에는 복구가 불가능하며
            <br />
            다시 이용시 새롭게 가입하셔야 합니다.
            <br />
            (이전 사용계정 사용불가)
          </p>
        </div>
      </div>

      {/* 버튼 영역 */}
      <div className="w-full flex flex-col gap-2">
        <AppButton onConfirm={onCancel} message="안해요" />
        <AppButton
          backgroundColor="#D4D4D4"
          boxShadowColor="#B7B7B7"
          onConfirm={deleteMember}
          style={{
            marginTop: 10,
          }}
          message="삭제하기"
        />
      </div>
    </div>
  );
};
